module.exports = __webpack_public_path__ + "site/img/59.729796eb.jpg";